(() => {
  function init(root=document){
    root.querySelectorAll('[data-divine-product]').forEach(section=>{
      if(section.dataset.ready)return;section.dataset.ready='true';
      section.querySelectorAll('[data-youtube-video]').forEach(video => {
        const poster = video.querySelector('[data-video-play]');
        const image = poster.querySelector('img');
        const id = video.dataset.youtubeVideo;
        // Prefer the original HD cover. Older videos may only have SD covers.
        const covers = ['maxresdefault.jpg', 'sddefault.jpg', 'hqdefault.jpg'];
        const loadCover = index => {
          if (index >= covers.length || !/^[\w-]{11}$/.test(id)) return;
          const probe = new Image();
          probe.onload = () => {
            if (probe.naturalWidth < 400) { loadCover(index + 1); return; }
            image.removeAttribute('srcset'); image.removeAttribute('sizes');
            image.src = probe.src;
          };
          probe.onerror = () => loadCover(index + 1);
          probe.src = 'https://i.ytimg.com/vi/' + id + '/' + covers[index];
        };
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); loadCover(0); }
          });
          observer.observe(video);
          const unload = event => { if (event.target.contains(video)) { observer.disconnect(); document.removeEventListener('shopify:section:unload', unload); } };
          document.addEventListener('shopify:section:unload', unload);
        } else loadCover(0);
        poster.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const frame = video.querySelector('template').content.querySelector('iframe')?.cloneNode(true);
          if (!frame) return;
          event.preventDefault();
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          video.append(frame); poster.hidden = true; frame.focus();
        });
      });
      function showMedia(id){
        const target=[...section.querySelectorAll('[data-product-media]')].find(el=>el.dataset.productMedia===id);
        if(!target)return;
        section.querySelectorAll('[data-product-media]').forEach(el=>{el.hidden=el!==target;if(el.hidden){el.querySelectorAll('video').forEach(video=>video.pause());el.querySelectorAll('[data-youtube-video]').forEach(video=>{video.querySelector('iframe')?.remove();video.querySelector('[data-video-play]').hidden=false;});}});
        section.querySelectorAll('[data-product-thumbnail]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.productThumbnail===id)));
      }
      section.querySelectorAll('[data-product-thumbnail]').forEach(button=>button.addEventListener('click',()=>showMedia(button.dataset.productThumbnail)));
      const form=section.querySelector('.divine-product-form');
      const variantField=form.querySelector('[data-product-variant-id]');
      const radios=[...form.querySelectorAll('input[name=divine-variant]')];
      radios.forEach(input=>input.addEventListener('change',()=>{
        if(!input.checked||input.disabled)return;
        // A single canonical id is read by Shopify forms and accelerated checkout.
        variantField.value=input.value;
        variantField.dispatchEvent(new Event('change',{bubbles:true}));
        section.querySelector('[data-product-price]').textContent=input.dataset.variantPrice;
        const add=section.querySelector('[name=add]');add.disabled=false;add.querySelector('span').textContent=add.dataset.addLabel;
        if(input.dataset.variantMedia)showMedia(input.dataset.variantMedia);
        const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState(null,'',url);
      }));
      const current=new URL(location.href).searchParams.get('variant');
      const requested=radios.find(input=>input.value===current);
      if(requested&&!requested.disabled){requested.checked=true;requested.dispatchEvent(new Event('change',{bubbles:true}));}
      else {
        const selected=radios.find(input=>input.value===variantField.value&&!input.disabled);
        if(selected)selected.checked=true;
      }
      section.dataset.variantReady='true';
      // Standard Shopify form submission carries variant ID, quantity, selling plan
      // and any future line-item properties to the real cart, including without JS.
    });
  }
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
